module.exports = __webpack_public_path__ + "img/empty-live-upcoming.ab1d74e1.svg";